import { Component, OnInit, Input } from "@angular/core";

import { DMVStoreService } from "../../services/dmv/dmv-store.service";
@Component({
	selector: "svg-definitions",
	templateUrl: "./svg-definitions.component.html",
	styleUrls: ["./svg-definitions.component.css"]
})
export class SvgDefinitionsComponent implements OnInit {
	public color: string;
	constructor(public dmvStoreService: DMVStoreService) {}

	ngOnInit() {}
}
